import axios, { AxiosInstance } from "axios";
import { ApiRoute } from "PFCore/utilities/routes";

let instance: AxiosInstance | null = null;

export const getInstance = () => {
  if (!instance) {
    instance = axios.create({
      baseURL: ApiRoute("/api/"),
      headers: {
        "Accept": "application/json",
        "Ui-Version": window.PF.config.ui_version
      }
    });
  }

  return instance;
};
